/*
 *
 * Groups actions
 *
 */

import { createAction } from '@reduxjs/toolkit';

import { SLICE_NAME } from './constants';
import { Group } from './groups';

export const fetchGroups = createAction<boolean>(`${SLICE_NAME}/fetchGroups`);

export const updateGroup = createAction<Partial<Group>>(
  `${SLICE_NAME}/updateGroup`,
);

export const removeGroup = createAction<string>(`${SLICE_NAME}/removeGroup`);
